export class ServiceEventNames {
    static DRAFT = "Draft";
    static SENT_BACK = "SentBack";
    static LESSEE_REJECTED = "LesseeRejected";
    static REJECTED = "Rejected";
    static PENDING_PAYMENT = "PendingPayment";
}

export class ServiceActionTypes {
    static VIEW = "view";
    static EDIT = "edit";
    static APPROVE = "approve";
    static SUBMIT = "Submit";
}


export class HorseGender {
    static MARE = "Mare";
    static STALLION = "Stallion";
    static GELDING = "Gelding";
}

export class PaymentTypeMethods {
    static HORSE_LEASING = 31;
    static INTERNATIONAL_BREEDING_CERTIFICATE = 32;
}

export class PaymentStatus {
    static COMPLETE = 'Complete';
}


export class PaymentRedirectUrls {
    static getEServicesRedirectUrl(serviceId) {
        const baseUrl = (process.env.REACT_APP_BASE_URL || window.location.origin).replace(/\/+$/, "");
        return `${baseUrl}/profile?activeTab=e_services${serviceId ? `&serviceId=${serviceId}` : ""}`;
    }

    static getEservicesUrl() {
        return `/profile?activeTab=e_services`;
    }
}

